.paper {
    padding: 10px;
    background: #fafafa !important;
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 0px rgba(0, 0, 0, 0.14), inset 0px 2px 1px -1px rgba(0, 0, 0, 0.12) !important;
}


.downloadSignedDocDiv {
    margin-left: 4.3%;
    display: flex;
    flex-direction: column;
    padding-left: 1.5%;
    border-radius: 3%;
    box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;
}


.downloadSignedDocDiv p {
    font-size: smaller;
    font-weight: bold;
    margin-top: 2%;
    margin-bottom: 1.5%;
}

.downloadSignedDocDiv span {
    margin-top: auto;
    font-size: 0.8rem;
    display: inline-flex;
    justify-content: space-around;
}

.downloadSignedDocDiv .downloadDocRadio {
    padding: 0;

}

.downloadFiles {
    display: flex;
    align-items: center;
    margin-right: 6%;
    margin-left: 1%;
    margin-top: -2%;
}

.downloadFiles .downloadIcon {
    color: #367c2b;
    }

.downloadError {
    color: #d24625;
}

.warningTooltip svg {
    margin-left: 5px;
}

.warningDiv {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.documentInfoPopup {
    padding-top: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
}

.primaryQuoteIcon {
  display:flex;
  flex-direction: row;
  justify-content:left;
}

.dropdownMenuDiv {
    display: flex;
    height: 2.6875rem;
    width: 9.9375rem;
}

.dropdownMenuDiv .dropdownFeature {
    background-color: white;
    height: 2.1875rem;
    width: 12.5rem;
}
